export class ErrorButtonHandler {
  constructor(text, cb) {
    this.text = text || "Error Occurred";
    this.cb = cb || (() => console.log("error occurred"));
  }
}
